// Behavioral Overlays Management
class BehavioralOverlays {
    constructor() {
        this.overlaysShown = new Set();
        this.exitIntentTriggered = false;
        this.timeBasedTriggered = false;
        this.scrollBasedTriggered = false;
        this.pageStartTime = Date.now();
        this.lastScrollY = window.scrollY;
        this.scrollDirection = 'down';
        
        this.init();
    }
    
    init() {
        // Check if overlay containers exist
        const container = document.querySelector('.behavioral-overlays-container');
        if (!container) {
            // console.log('BehavioralOverlays: No overlay container found');
            return;
        }
        
        // Debug: Check which overlays are in the DOM
        const exitOverlay = document.getElementById('exitIntentOverlay');
        const timeOverlay = document.getElementById('timeBasedOverlay');
        const scrollOverlay = document.getElementById('scrollBasedOverlay');
        const testOverlay = document.getElementById('testOverlay');
        
        // console.log('BehavioralOverlays: DOM overlays found:');
        // console.log('- Exit overlay:', exitOverlay ? 'YES' : 'NO');
        // console.log('- Time overlay:', timeOverlay ? 'YES' : 'NO');
        // console.log('- Scroll overlay:', scrollOverlay ? 'YES' : 'NO');
        // console.log('- Test overlay:', testOverlay ? 'YES' : 'NO');
        
        
        this.setupExitIntent();
        this.setupTimeBasedTrigger();
        this.setupScrollBasedTrigger();
        this.setupOverlayHandlers();
    }
    
    isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    
    shouldShowOnMobile() {
        // Return true if you want overlays to show on mobile too
        return true;
    }
    
    setupExitIntent() {
        // Check if exit overlay exists in DOM first
        const exitOverlay = document.getElementById('exitIntentOverlay');
        if (!exitOverlay) {
            console.log('BehavioralOverlays: Exit overlay not found in DOM, skipping exit intent setup');
            return;
        }
        
        console.log('BehavioralOverlays: Setting up exit intent');
        document.addEventListener('mouseleave', (e) => {
            // Only trigger when cursor moves to the very top of the page
            if (e.clientY <= 5 && !this.exitIntentTriggered) {
                console.log('BehavioralOverlays: Exit intent triggered');
                this.exitIntentTriggered = true;
                this.showOverlay('exitIntentOverlay', 'exit-intent');
            }
        });
    }
    
    setupTimeBasedTrigger() {
        setTimeout(() => {
            if (!this.timeBasedTriggered) {
                // Check if time-based overlay exists in DOM
                const timeOverlay = document.getElementById('timeBasedOverlay');
                if (!timeOverlay) {
                    console.log('BehavioralOverlays: timeBasedOverlay not found in DOM');
                    return;
                }
                
                this.timeBasedTriggered = true;
                this.showOverlay('timeBasedOverlay', 'time-based');
            } else {
                // console.log('BehavioralOverlays: Time-based already triggered');
            }
        }, 5000); // 5 seconds for testing (change back to 30000 when working)
    }
    
    setupScrollBasedTrigger() {
        // Check if scroll overlay exists in DOM first
        const scrollOverlay = document.getElementById('scrollBasedOverlay');
        if (!scrollOverlay) {
            // console.log('BehavioralOverlays: Scroll overlay not found in DOM, skipping scroll trigger setup');
            return;
        }
        
        // Get scroll depth percentage from data attribute or default to 70%
        const container = document.querySelector('.behavioral-overlays-container');
        const scrollDepth = container ? (parseInt(container.dataset.scrollDepth) || 70) : 70;

        // console.log('BehavioralOverlays: Scroll depth set to:', scrollDepth + '%');

        const scrollHandler = () => {
            if (this.scrollBasedTriggered || this.overlaysShown.has('scroll-based')) {
                return;
            }
            
            const currentScrollY = window.scrollY;
            const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollPercentage = (currentScrollY / documentHeight) * 100;

            // console.log('BehavioralOverlays: Current scroll:', Math.round(scrollPercentage) + '%');

            // Trigger immediately when reaching the specified depth
            if (scrollPercentage >= scrollDepth) {
                this.scrollBasedTriggered = true;
                // console.log('BehavioralOverlays: Scroll-based trigger activated at', Math.round(scrollPercentage) + '% depth (target: ' + scrollDepth + '%)');
                this.showOverlay('scrollBasedOverlay', 'scroll-based');
                window.removeEventListener('scroll', scrollHandler);
            }
        };
        
        // Enable scroll trigger immediately (no delay)
        window.addEventListener('scroll', scrollHandler, { passive: true });
    }
    
    showOverlay(overlayId, triggerType) {
        // Don't show if user has already seen an overlay in this session
        if (this.overlaysShown.size > 0) {
            // console.log('BehavioralOverlays: Another overlay already shown this session, blocking');
            return;
        }
        
        // Hide any currently active overlays first
        const activeOverlay = document.querySelector('.behavioral-overlay.active');
        if (activeOverlay) {
            activeOverlay.classList.remove('active');
        }
        
        // Check if user has dismissed this type recently (localStorage) - COMMENTED OUT FOR TESTING
        // const dismissKey = `overlay_dismissed_${triggerType}`;
        // const lastDismissed = localStorage.getItem(dismissKey);
        
        // if (lastDismissed) {
        //     const dismissedTime = parseInt(lastDismissed);
        //     const hoursSinceDismissed = (Date.now() - dismissedTime) / (1000 * 60 * 60);
            
        //     // Don't show again for 24 hours
        //     if (hoursSinceDismissed < 24) {
        //         console.log('BehavioralOverlays: Overlay dismissed recently (' + Math.round(hoursSinceDismissed * 100) / 100 + ' hours ago), not showing');
        //         return;
        //     }
        // }
        
        const overlay = document.getElementById(overlayId);
        if (!overlay) {
            return;
        }
        
        overlay.classList.add('active');
        document.body.classList.add('overlay-active');
        document.documentElement.classList.add('overlay-active');
        this.overlaysShown.add(triggerType);
        
        // Track overlay shown event
        this.trackEvent('overlay_shown', triggerType);
        
        // Focus trap
        const focusableElements = overlay.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        
        if (focusableElements.length > 0) {
            focusableElements[0].focus();
        }
    }
    
    hideOverlay(overlayId, triggerType, dismissed = false) {
        const overlay = document.getElementById(overlayId);
        if (!overlay) return;
        
        overlay.classList.remove('active');
        document.body.classList.remove('overlay-active');
        document.documentElement.classList.remove('overlay-active');
        
        if (dismissed) {
            // Store dismissal time
            const dismissKey = `overlay_dismissed_${triggerType}`;
            localStorage.setItem(dismissKey, Date.now().toString());
            
            // Track dismissal event
            this.trackEvent('overlay_dismissed', triggerType);
        } else {
            // Track conversion event
            this.trackEvent('overlay_converted', triggerType);
        }
    }
    
    setupOverlayHandlers() {
        document.addEventListener('click', (e) => {
            // Handle overlay close buttons
            if (e.target.classList.contains('overlay-close') || 
                e.target.closest('.overlay-close')) {
                
                const overlay = e.target.closest('.behavioral-overlay');
                if (overlay) {
                    const triggerType = overlay.dataset.trigger;
                    this.hideOverlay(overlay.id, triggerType, true);
                }
            }
            
            // Handle overlay dismiss buttons
            if (e.target.classList.contains('overlay-dismiss')) {
                const overlay = e.target.closest('.behavioral-overlay');
                if (overlay) {
                    const triggerType = overlay.dataset.trigger;
                    this.hideOverlay(overlay.id, triggerType, true);
                }
            }
            
            // Handle overlay CTA buttons
            if (e.target.classList.contains('overlay-cta')) {
                const overlay = e.target.closest('.behavioral-overlay');
                if (overlay) {
                    const triggerType = overlay.dataset.trigger;
                    this.hideOverlay(overlay.id, triggerType, false);
                }
            }
            
            // Handle backdrop clicks
            if (e.target.classList.contains('overlay-backdrop')) {
                const overlay = e.target.closest('.behavioral-overlay');
                if (overlay) {
                    const triggerType = overlay.dataset.trigger;
                    this.hideOverlay(overlay.id, triggerType, true);
                }
            }
        });
        
        // Handle escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                const activeOverlay = document.querySelector('.behavioral-overlay.active');
                if (activeOverlay) {
                    const triggerType = activeOverlay.dataset.trigger;
                    this.hideOverlay(activeOverlay.id, triggerType, true);
                }
            }
        });
    }
    
    trackEvent(eventName, triggerType) {
        // Google Analytics 4 tracking
        if (typeof gtag !== 'undefined') {
            gtag('event', eventName, {
                'event_category': 'Behavioral Overlay',
                'event_label': triggerType,
                'value': 1
            });
        }
        
        // GTM DataLayer tracking
        if (window.dataLayer) {
            window.dataLayer.push({
                'event': eventName,
                'overlay_type': triggerType,
                'event_category': 'Behavioral Overlay'
            });
        }
        
        // Console log for debugging
        console.log(`Overlay Event: ${eventName} - ${triggerType}`);
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Initialize behavioral overlays
    new BehavioralOverlays();
    
    // Initialize property card gallery triggers (if not already handled)
    const galleryTriggers = document.querySelectorAll('.gallery-trigger');
    galleryTriggers.forEach(trigger => {
        if (!trigger.hasAttribute('onclick')) {
            trigger.addEventListener('click', function() {
                const images = JSON.parse(this.dataset.propertyImages || '[]');
                const propertyName = this.dataset.propertyName || 'Property';
                
                if (images.length > 0 && typeof openGalleryModal === 'function') {
                    openGalleryModal(images, propertyName);
                }
            });
        }
    });
});

// Expose for global access if needed
window.BehavioralOverlays = BehavioralOverlays;